module.exports = __webpack_public_path__ + "assets/media/day16.b44eb177.mp3";